import { Empty, Pagination } from "antd";
import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import api from "shared/infra/services/api";
import Review from "./SingleReview";
import { Content, PaginationContainer } from "./styles";

const Assessments = ({ entityId, rateFilter, contentType }) => {
  const { t } = useTranslation();

  const [reviews, setReviews] = useState(1);
  const [reviewsCurrentPage, setReviewsCurrentPage] = useState(1);
  const [newReviews, setNewReviews] = useState([]);

  function onChangeReviewsCurrentPage(page) {
    setReviewsCurrentPage(page);
  }

  useEffect(() => {
    const getReviews = async () => {
      if (entityId) {
        try {
          const response = await api.get(
            `review/?contentable_type=${contentType}&contentable_id=${entityId}&page=${reviewsCurrentPage}&per_page=${5}`,
          );

          setReviews(response.data);
        } catch (error) {
          console.log("error --> ", error);
        }
      }
    };

    getReviews();
  }, [entityId, reviewsCurrentPage, contentType, rateFilter]);

  return (
    <>
      {reviews && (
        <>
          <Content>
            {newReviews.length > 0 &&
              newReviews.reverse().map((review, index) => (
                <React.Fragment key={review.data.id}>
                  {index !== 0 && <hr style={{ margin: 0 }} />}
                  <Review
                    review={review.data}
                    entityId={entityId}
                    stateArray="newlyCreatedReviews"
                  />
                </React.Fragment>
              ))}
            {reviews?.data?.length > 0 &&
              reviews?.data?.map((review, index) => {
                if (!review.data.user) return null;
                return (
                  <React.Fragment key={review.data.id}>
                    {(index !== 0 || newReviews.length > 0) && (
                      <hr style={{ margin: 0 }} />
                    )}
                    <Review
                      review={review.data}
                      entityId={entityId}
                      stateArray="reviews"
                    />
                  </React.Fragment>
                );
              })}
            {!reviews?.data?.length && !newReviews.length && (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={t("common:thisCourseHasNoReviewsYet")}
              />
            )}
          </Content>
          {reviews?.data?.length > 0 && (
            <PaginationContainer>
              <Pagination
                defaultCurrent={reviewsCurrentPage}
                onChange={onChangeReviewsCurrentPage}
                pageSize={Number(reviews?.meta?.per_page)}
                total={reviews?.meta?.total}
              />
            </PaginationContainer>
          )}
        </>
      )}
    </>
  );
};

Assessments.defaultProps = {
  entityId: null,
  rateFilter: null,
  hasReviewed: true,
  completePercentage: 100,
};

Assessments.propTypes = {
  hasReviewed: PropTypes.bool,
  rateFilter: PropTypes.number,
  completePercentage: PropTypes.number,
  writeStatus: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
  hasEnrollment: PropTypes.bool.isRequired,
  startEnrollment: PropTypes.bool.isRequired,
  entityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Assessments;
